import { Crud } from "@/api";
import {
  ShippingMethod,
  ShippingStatus,
  WorkList,
  WorkListGroup,
  WorkListStatus,
  WorklistColumn,
} from "@/utils/types/types";
import { timed } from "@/utils/loaderLogger";
import { LoaderFunctionArgs } from "react-router-dom";

export type MasterlistGroupData = {
  group: WorkListGroup | null;
  worklists: WorkList[];
  worklistGroups: WorkListGroup[];
  worklistStatuses: WorkListStatus[];
  worklistColumns: WorklistColumn[];
  shippingMethods: ShippingMethod[];
  shippingStatuses: ShippingStatus[];
};

export default function dashboardMasterlistGroupLoader({
  params,
}: LoaderFunctionArgs) {
  const groupId = params.groupId as string;

  const data: Promise<MasterlistGroupData> = Promise.all([
    timed("worklistGroups.getAll", Crud.worklistGroups.getAll()),
    timed("worklistStatuses.getAll", Crud.worklistStatuses.getAll()),
    timed("worklistColumns.getAll", Crud.worklistColumns.getAll()),
    timed("shippingMethods.getAll", Crud.shippingMethods.getAll()),
    timed("shippingStatuses.getAll", Crud.shippingStatuses.getAll()),
    timed(
      `worklists.getAll(group:${groupId})`,
      Crud.worklists.getAll({ workListGroupId: groupId } as any)
    ),
  ]).then(
    ([
      worklistGroups,
      worklistStatuses,
      worklistColumns,
      shippingMethods,
      shippingStatuses,
      worklists,
    ]) => ({
      group: worklistGroups.find(g => g.id === groupId) ?? null,
      worklists,
      worklistGroups,
      worklistStatuses,
      worklistColumns,
      shippingMethods,
      shippingStatuses,
    })
  );

  return { data };
}
